import useApolloClient from '../hooks/useApolloClient';
import { Route, Switch } from 'react-router-dom';
import Assemblies from '../pages/assemblies/Assemblies';
import Customers from '../pages/customers/Customers';
import { ModeProvider } from '../hooks/useMode';
import Jobs from '../pages/jobs/Jobs';
import Users from '../pages/users/Users';
import Testers from '../pages/testers/Testers';
import Home from '../pages/Home';
import { ApolloProvider } from '@apollo/client';
import React from 'react';
import CompanyProfile from './company/pages/profile/CompanyProfile';
import EmailSettings from './company/pages/profile/EmailSettings';
import Notices from '../pages/notices/Notices';
import NoticesEditor from '../pages/notices/NoticesEditor';
import Activity from '../pages/activity/Activity';
import NotificationSettings from './common/pages/settings/NotificationSettings';
import ActivityHandler from '../components/ActivityFeed/ActivityHandler';
import { TwoFactorPrompt } from '../components/Security';

const Company = () => {
  return (
    <ApolloProvider client={useApolloClient('company')}>
      <ModeProvider value="company">
        <ActivityHandler />
        <TwoFactorPrompt />
        <Switch>
          <Route path="/company/activity" component={Activity} />
          <Route
            path={['/company/jobs/:id', '/company/jobs']}
            component={Jobs}
          />
          <Route
            path={['/company/assemblies/:id', '/company/assemblies']}
            component={Assemblies}
          />
          <Route
            path={['/company/customers/:id', '/company/customers']}
            component={Customers}
          />
          <Route
            path={['/company/users/:id', '/company/users']}
            component={Users}
          />
          <Route
            path={['/company/testers/:id', '/company/testers']}
            component={Testers}
          />
          <Route path="/company/notices/:id" component={NoticesEditor} />
          <Route path="/company/notices" component={Notices} />
          <Route
            path="/company/notification-settings"
            component={NotificationSettings}
          />
          <Route path="/company/profile" component={CompanyProfile} />
          <Route path="/company/email-settings" component={EmailSettings} />
          <Route path="/company" component={Home} />
        </Switch>
      </ModeProvider>
    </ApolloProvider>
  );
};

export default Company;
